export default "__VITE_ASSET__BoibOZuf__"